import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { setNewHireEnrollmentCoverage } from '../../../../arc/features/new-hire-enrollment/slice/new-hire-enrollment-slices';
import { getMidYearCoverage } from '../../../../../global/ducks/mlps-api';
import { useMyCpgMidYearOpenEnrollments } from '../../../../../global/hooks/useMyCpgMidYearOpenEnrollments';
import { apiErrorClear } from '../../../../../global/ducks/base-api';

export function useMyCpgMidyearState() {
	const loaded = useSelector<TcsmStates, boolean>(state => state.newHireEnrollmentState?.newHireCoverageLoaded);
	const openEnrollments = useMyCpgMidYearOpenEnrollments();
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);
	const dispatch = useDispatch();
	
	useEffect(() => {
		if (!loaded && openEnrollments && openEnrollments[0]?.id) {
			const formId = openEnrollments[0]?.id;
			dispatch(getMidYearCoverage(guid, Number(formId), (response) => {
				dispatch(apiErrorClear());
				dispatch(setNewHireEnrollmentCoverage(response?.data));
			}));
		}
	}, [openEnrollments]);

	return loaded;
}